// extracted by mini-css-extract-plugin
export var addressSection = "footer-module--addressSection--sFbaF";